import { Either, Option } from 'funfix-core';
import { Record } from 'immutable';
export const makeUrlContextIcon = urlIcon => Either.left(urlIcon);
export const makeReactContextIcon = reactIcon => Either.right(reactIcon);
export const makeContext = Record({
  id: '',
  icon: Option.none(),
  name: undefined,
  type: undefined
});
export const makeContextFromSPIContext = spiContext => makeContext({
  id: spiContext.id,
  icon: Option.of(spiContext.icon).map(makeUrlContextIcon),
  name: spiContext.name,
  type: spiContext.type
});
export const defaultContextName = 'Atlassian Marketplace';